import { ActivatedRoute } from '@angular/router';
import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { KozDokument } from './koz-dokument';

@Component({
  selector: 'yt-koz-dokument-tab-update',
  templateUrl: './koz-dokument-tab-update.component.html'
})
export class KozDokumentTabUpdateComponent extends BaseTabsUpdateComponent<KozDokument> implements OnInit {

  constructor(protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<KozDokument>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
